import { Channel } from "@capacitor/push-notifications";
import { NotificationType } from "src/shared/models/push-notification/push-notification";

export const PUSH_NOTIFICATION_CHANNELS: Channel[] = [
    {
        id: NotificationType.None.toString(),
        name: 'Default',
        importance: 4,
    }, {
        id: NotificationType.DutyMessage.toString(),
        name: 'Duties',
        importance: 4,
    }, {
        id: NotificationType.PinboardPost.toString(),
        name: 'Pinboard posts',
        importance: 4,
    }, {
        id: NotificationType.MessageReply.toString(),
        name: 'Messages',
        importance: 4,
    }, {
        id: NotificationType.NewNotificationFromRota.toString(),
        name: 'Notifications sent by Rota',
        importance: 4,
    }, {
        id: NotificationType.EnquiryMessage.toString(),
        name: 'Enquiries',
        importance: 4,
    }, {
        id: NotificationType.RequestMessage.toString(),
        name: 'Requests',
        importance: 4,
    }, {
        id: NotificationType.PresenceMonitoring.toString(),
        name: 'Presence Monitoring',
        importance: 4,
    }, {
        id: NotificationType.Info.toString(),
        name: 'Info',
        importance: 4,
    }, {
        id: NotificationType.Statistic.toString(),
        name: 'Statistics',
        importance: 4,
    },
]